import React, { useRef, useEffect } from 'react'; // useEffect را اضافه کنید
import { Link } from 'react-router-dom';
import { Fade } from "react-awesome-reveal";
import { Swiper, SwiperSlide } from 'swiper/react'; // Swiper و SwiperSlide را ایمپورت کنید
import 'swiper/swiper-bundle.css'; // استایل‌های Swiper را ایمپورت کنید
import Bg from '../../images/bg/hero-bg01.jpg';
import Bg2 from '../../images/shape/hero-glassisom.png';
import hImg from '../../images/hero/hero-img01.png';
import shape1 from '../../images/shape/hero-shape01.png';
import shape2 from '../../images/shape/hero-shape04.png';
import { Navigation } from 'swiper';

const Hero2 = ({ data }) => {
    const prevRef = useRef(null);
    const nextRef = useRef(null);
    const swiperRef = useRef(null);

    useEffect(() => {
        if (swiperRef.current && prevRef.current && nextRef.current) {
            swiperRef.current.params.navigation.prevEl = prevRef.current;
            swiperRef.current.params.navigation.nextEl = nextRef.current;
            swiperRef.current.navigation.init();
            swiperRef.current.navigation.update();
        }
    }, []);

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    };

    return (
        <Swiper
            modules={[Navigation]} // ماژول Navigation را اضافه کنید
            spaceBetween={50}
            slidesPerView={1}
            loop={true}
            speed={1800}
            parallax={true}
            navigation={{
                prevEl: prevRef.current,
                nextEl: nextRef.current,
            }}
            onBeforeInit={(swiper) => {
                swiperRef.current = swiper;
            }}
        >
            {data.map((item, Bitem) => (
                <SwiperSlide key={Bitem}>
                    <section className="hero hero-style-one pos-rel bg_img" style={{ backgroundImage: `url(${item.files_main_path + item.files[0].file_name})` }}>
                        <div className="hero-shape">
                            <div className="shape shape--one bg_img" style={{ backgroundImage: `url(${Bg2})` }}></div>
                            <div className="shape shape--two"><img src={shape1} alt="" /></div>
                            <div className="shape shape--three"><img src={shape2} alt="" /></div>
                        </div>
                        <div className="container">
                            <div className="hero_wrap">
                                <div className="row">
                                <div className="col-md-6">
                                        <div className="">
                                            <img className="wow skewIn" data-wow-duration="800ms" src={item.file_path} alt="" />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="xb-hero">
                                            <Fade direction='up' triggerOnce={'false'} duration={800} delay={6}>
                                                <div>
                                                    <h1 className="xb-item--title wow fadeInUp text-end" data-wow-duration="600ms">{item.title}</h1>
                                                </div>
                                            </Fade>
                                            <Fade direction='up' triggerOnce={'false'} duration={1500} delay={9}>
                                                <div>
                                                    <p className="xb-item--content wow fadeInUp text-end" data-wow-delay="150ms" data-wow-duration="600ms">{item.summary}</p>
                                                </div>
                                            </Fade>
                                            <Fade direction='up' triggerOnce={'false'} duration={1800} delay={9}>
                                                <div>
                                                    <div className="xb-btn wow mt-60 fadeInUp text-center text-lg-end mb-4" data-wow-delay="300ms" data-wow-duration="600ms">
                                                        <Link onClick={ClickHandler} to="/contact" className="thm-btn thm-btn--fill_icon thm-btn--white_icon">
                                                            <div className="xb-item--hidden"><span className="xb-item--hidden-text" dangerouslySetInnerHTML={{__html: item.body}}></span></div>
                                                            <div className="xb-item--holder">
                                                                <span className="xb-item--text" dangerouslySetInnerHTML={{__html: item.body}}></span>
                                                                <div className="xb-item--icon"><i className="far fa-long-arrow-right"></i></div>
                                                                <span className="xb-item--text" dangerouslySetInnerHTML={{__html: item.body}}></span>
                                                            </div>
                                                        </Link>
                                                    </div>
                                                </div>
                                            </Fade>
                                        </div>
                                    </div>
                                  
                                </div>
                            </div>
                        </div>
                    </section>
                </SwiperSlide>
            ))}
        </Swiper>
    );
};

export default Hero2;